export default {
  '401': '認証失敗、システムリソースにアクセスできません',
  '403': '現在の操作には権限がありません',
  '404': 'アクセス リソースが存在しません',
  'default': 'システムの不明なエラーです。管理者にフィードバックしてください',
  /**
   * メッセージ一覧
   */
  'MSG-KT-I0001': '編集をキャンセルしてもよろしいですか？',
  'MSG-KT-I0002': '{0}をします。よろしいですか?',
  'MSG-KT-I0003': '{0}の{1}が完了しました。',
  'MSG-KT-I0004': '{0}が完了しました。',
  'MSG-KT-I0005': '対象データが見つかりませんでした。',
  'MSG-KT-I0006': '入力した情報が反映されていません。\n画面を離れますか？',
  'MSG-KT-I0007': 'OCRによる読み込みを開始します。\n\n＊「キャンセル」ボタンを押下するとファイルの読み込みを中止します。\n＊「OK」ボタンを押下するとダイアログが閉じられ、ファイルの読み込みを開始します。',
  'MSG-KT-E0001': '{0}は入力必須です。',
  'MSG-KT-E0002': '{0}は選択必須です。',
  'MSG-KT-E0003': '{0}の型が不正です。',
  'MSG-KT-E0004': '{0}には{1}文字以下で入力してください。',
  'MSG-KT-E0005': '{0}には{1}文字以上で入力してください。',
  'MSG-KT-E0006': '{0}には{1}～{2}文字で入力してください。',
  'MSG-KT-E0007': '{0}には{1}以下の数値を入力してください。',
  'MSG-KT-E0008': '{0}には{1}以上の数値を入力してください。',
  'MSG-KT-E0009': '{0}には{1}～{2}の数値を入力してください。',
  'MSG-KT-E0010': '{0}は{1}以降の値を入力してください。',
  'MSG-KT-E0011': '{0}には有効な日付を指定してください。',
  'MSG-KT-E0012': '{0}には過去の日付を入力してください。',
  'MSG-KT-E0013': '{0}には当日以降の日付を入力してください。',
  'MSG-KT-E0014': '{0}には当日以降の日付を入力してください。',
  'MSG-KT-E0015': '{0}には{1}以前の日付を入力してください。',
  'MSG-KT-E0016': '{0}には{1}以降の日付を入力してください。',
  'MSG-KT-E0017': '{0}の終了日は開始日以降の日付を入力してください。',
  'MSG-KT-E0018': '{0}を入力した場合、{1}は入力必須です。',
  'MSG-KT-E0019': '{0}を選択した場合、{1}は入力必須です。',
  'MSG-KT-E0020': '{0}を入力した場合、{1}は選択必須です。',
  'MSG-KT-E0021': '{0}を選択した場合、{1}は選択必須です。',
  'MSG-KT-E0022': '{0}に{1}を入力した場合、{2}は入力必須です。',
  'MSG-KT-E0023': '{0}に{1}を選択した場合、{2}は入力必須です。',
  'MSG-KT-E0024': '{0}に{1}を入力した場合、{2}は選択必須です。',
  'MSG-KT-E0025': '{0}に{1}を選択した場合、{2}は選択必須です。',
  'MSG-KT-E0026': '{0}に{1}を選択した場合、{2}は一つだけ選択してください。',
  'MSG-KT-E0027': '{0}に{1}を選択した場合、{2}は複数選択してください。',
  'MSG-KT-E0028': '{0}は複数選択不可です。',
  'MSG-KT-E0029': '{0}に重複した値を{1}しないでください。',
  'MSG-KT-E0030': '移動ページの指定が不正です。',
  'MSG-KT-E0031': '別のユーザによって更新されました。最新情報を取得してください。',
  'MSG-KT-E0032': 'ファイルサイズが上限値（{0}）を超えています。',
  'MSG-KT-E0033': 'ファイルの拡張子は{0}でアップロードしてください。',
  'MSG-KT-E0034': '選択した入力ファイルのフォーマットが一致していません。',
  'MSG-KT-E0035': '指定したファイルは存在しない、または削除済みです。',
  'MSG-KT-E0036': '指定した{0}のアクセス権限がありません。',
  'MSG-KT-E0037': '{0}の{1}が失敗しました。',
  'MSG-KT-E0038': '{0}が失敗しました。',
  'MSG-KT-E0039': 'システムエラーが発生しました。しばらく時間をおいてから再度実行してください。\n解消されない場合は、システム管理者にお問合せください。',
  'MSG-KT-E0040': 'メール送信が失敗しました。\nしばらく時間をおいてから再度お試しください。\n再度お試しいただいても改善されない場合は\nシステム管理者にご連絡ください。',
  'MSG-KT-E0041': 'ファイルの分類変更中です。\nしばらく時間をおいてから再度お試しください。',
  'MSG-KT-E0042': 'ファイルの拡張子は{0}を指定してください。',
  'MSG-KT-E0043': '{0}に同じファイルを{1}しないでください。',
  'MSG-TK-E0001': '{0}の第{1}表の前月（前年）の未済件数と当月（当年）の旧受件数が合致しないため、提出できません。',
  'MSG-TK-E0002': '旧受、新受の件数の合計と既済、未済の件数の合計が不一致です。',
  'MSG-TK-E0003': '過去に修正されたデータは破棄され、仮登録から再実行となります。',
  'MSG-TK-E0004': '年の設定は今年以前の年を設定してください。',
  'MSG-TK-E0005': '月の設定は今月以前の月を設定してください。',
  'MSG-TK-E0006': '第{0}表は提出中もしくは確認済のため、実行できません。',
  'MSG-TK-E0007': '対象年と月を組み合わせての出力はできません。',
  'MSG-TK-E0008': '指定した期間に未確定の統計表が含まれるため出力できません。',
  'MSG-TK-E0009': '選択した統計表は提出中もしくは確認済のため、実行できません。',
  'MSG-TK-E0010': '{0}～{1}の数値を入力してください。',
  'MSG-TK-E0011': '{0}の局に統計取扱責任者がいないため、{1}できません。',
  'MSG-SS-I0001': '第一審の事件情報登録画面へ移動します。よろしいですか？',
  'MSG-SS-I0002': '各取扱責任者に承認依頼の通知をします。よろしいですか？',
  'MSG-SS-E0001': '添付ファイルのアップロード中のため、しばらくお待ちください。',
  'MSG-SS-E0002': '最下部のファイルの終了ページ番号が総ページ数と一致していません。',
  'MSG-SS-E0003': '事件転写する場合、事件は1つだけ選択してください。',
  'MSG-SS-E0004': '画面上部と下部のファイル種別が一致しません。',
  'MSG-SS-E0005': '併合事件グループ登録画面より事件記録保存を実行してください。',
  'MSG-SS-E0006': '併合先（親）事件の結果票がまだ未承認です。',
  'MSG-SS-E0007': '終了ページ番号を開始ページ番号より大きくしてください。',
  'MSG-SS-E0008': '未確定ファイル一覧にファイルが残っています。処理を完了させてください。',
  'MSG-SS-E0009': '事件記録が保存済みのため、取消はできません。',
  'MSG-SS-E0010': 'フォルダ配下に子フォルダまたはファイルが存在するため削除できません。',
  'MSG-SS-E0011': '受理・申立等・結果・確定報告書はすべて作成済のため、新規作成できません。',
  'MSG-SS-E0012': 'グループ設定をする場合は複数の事件を選択してください。',
  'MSG-SS-E0013': '併合事件グループ登録は1種類のグループを選択してください。',
  'MSG-SS-E0014': '併合先／元を入れ替える場合は、グループ解除の後にグループを再設定してください。',
  'MSG-SS-E0015': 'ファイルは{0}ファイル以下で選択してください。',
  'MSG-SS-E0016': '{0}行{1}列に{2}ため、修正してください。',
  'MSG-SS-E0017': '処理未完了のファイルあるいは処理区分変更履歴の処理終了日が未入力のデータがあり、事件記録保存不可です。',
  'MSG-SS-E0018': '入力した{0}は存在しません。',
  'MSG-SS-E0019': '{0}と{1}の件数が一致しません。',
  'MSG-SS-E0020': '付加情報登録が行われていないため、処理終了年月日を設定できません。',
  'MSG-SS-E0021': '別の事件記録で同じ事件番号が存在しましたので、登録できません。',
  'MSG-SS-E0022': '併合先事件の結果票が完了していないため事件記録保存を実行できません。',
  'MSG-SS-E0023': '処理終了登録がされていないため事件記録保存を実行できません。',
  'MSG-SS-E0024': '併合事件グループ内事件の処理担当局が異なっているため、処理終了登録が実行できません。',
  'MSG-SS-E0025': '{0}の事件情報が存在しないので、{1}の事件情報が登録できません。',
  'MSG-SS-E0026': '併合先事件は複数選択できません。',
  'MSG-SS-E0027': '終了済みの事件が含まれているためグループ設定が実行できません。',
  'MSG-SS-E0028': '該当グループが存在しません。',
  'MSG-SS-E0029': '既存分類と重複しない分類名を入力してください。',
  'MSG-SS-E0030': '分類フォルダ名とファイル名の全長は200文字以下で入力してください。',
  'MSG-SS-E0031': '既存ファイルと重複しないファイル名を入力してください。',
  'MSG-SS-E0032': '選択された事件の処理担当局が異なっているため、グループ設定が実行できません。',
  'MSG-SS-E0033': '併合事件グループ登録は複数の事件を選択してください。',
  'MSG-SS-E0034': '併合事件グループ登録は争訟事件のみ選択してください。',
  'MSG-SS-E0035': '対象の分類にデータを作成中です。\nしばらく時間をおいてから再度お試しください。',
  'MSG-SS-E0036': '項目編集中のファイルが存在するファイル分類の名称を修正することはできません。\nファイルの登録が完了してから、表示画面にて分類名の変更を行ってください。',
  'MSG-SS-E0037': '同じ分類配下に同じ名前のファイルは登録できません。',
  'MSG-SS-E0038': 'この事件番号は登録済みです。同一事件記録以外で事件番号を重複して登録することはできません。',
  'MSG-SS-E0039': '同じファイル名のファイルが存在するため、アップロードできません。',
  'MSG-SS-E0040': 'グループ設定されているため、個別での登録はできません。',
  'MSG-SS-E0041': '併合先事件が立件前のため、グループ設定処理が実行できません。',
  'MSG-SS-E0042': '併合事件グループ内事件に立件していない事件が存在するため、{0}が実行できません。',
  'MSG-SS-I0003': '{0}を確認しますか。',
  'MSG-SS-I0004': '{0}の確認を取消しますか。',
  'MSG-SS-I0005': '{0}を承認しますか。',
  'MSG-SS-I0006': '{0}の承認を取消しますか。',
  'MSG-JK-E0001': '指定したファイルのアクセス権限がありません。',
  'MSG-JK-E0002': '選択した事件について閲覧権限がありません。',
  'MSG-GK-I0001': 'ログアウトしますか？',
  'MSG-GK-E0001': 'ユーザIDがロックされています。システム管理者へお問合せください。',
  'MSG-GK-E0002': '新しいパスワードと新しいパスワード(確認)が不一致です。',
  'MSG-GK-E0003': 'パスワードは数字、英字大文字、英字小文字、記号を３種類以上を組み合わせ、15文字以上で入力してください。',
  'MSG-GK-E0004': '仮パスワードを発行できません。',
  'MSG-GK-E0005': '確認コードが違います。',
  'MSG-GK-E0006': '確認コードの有効期限が切れています。',
  'MSG-SK-I0001': '文書管理者に廃棄依頼をします。よろしいですか？\n※廃棄依頼は選択した事件（審級）を含めた事件記録単位で行われます。',
  'MSG-SK-W0001': '{0}タグがありません。確認してください。',
  'MSG-SK-W0002': '選択された事件のユーザを引継ぎ、データを再検索します\n登録が必要なデータは全て選択してください\n処理を続行しますか？',
  'MSG-SK-W0003': '処理を続行すると編集中のデータが破棄されます。\nあらかじめ登録処理を行ってください。\n処理を続行しますか？',
  'MSG-SK-W0004': '登録を完了するためには、再度本画面にアクセスし、「登録」ボタンを押下する必要があります。\n画面を離れますか？',
  'MSG-SK-W0005': '{0}は変換できませんでした。',
  'MSG-SK-E0001': '{0}データのフォーマットが不正です。',
  'MSG-SK-E0002': 'PDFとテキストファイルのファイル名が一致しません。',
  'MSG-SK-E0003': '入力上のエラー(事件番号：{0})年号が解析できません。',
  'MSG-SK-E0004': '入力されたユーザIDは既に登録されています。',
  'MSG-SK-E0005': '{0}を正しい日付として認識できません。',
  'MSG-SK-E0006': '{0}を数値として認識できません。',
  'MSG-SK-E0007': '{0}：{1}には下位階層が存在するため削除できません。',
  'MSG-SK-E0008': '{0}：{1}は既に使用されているため削除できません。',
  'MSG-SK-E0009': '{0}には同じファイル名を登録できません。',
  'MSG-SK-E0010': '時報PDFと分割PDF、テキストファイルのファイル名の年月が一致しません。',
  'MSG-SK-E0011': '同じファイル名のファイルが存在するため、登録できません。',
  'MSG-SK-E0012': '{0}ファイル名のフォーマットが不正です。',
  'MSG-SK-E0013': '担当する事件を引継いでから削除してください。',
  'MSG-SK-E0014': '{0}が取得できません。',
  'MSG-SK-E0015': '入力不可文字があるので、{0}できません。',
  'MSG-SK-E0016': '選択した事件に、引継ぎ先ユーザが未設定の事件が含まれているため、引継ぎ実行できません。事件番号：{0}',
  'MSG-SK-E0017': 'html指定項目以外の項目は，内容部分には「<」「>」を使用できません。項目名：{0}',
  'MSG-SK-E0018': '有効なメールアドレスを入力してください。',
  'MSG-SK-E0019': '引継ぎ先ユーザには同じユーザを複数指定できません。事件番号：{0}',
  'MSG-SK-E0020': '{0}の数が異なる為、テキストの取込ができません',
  'MSG-SK-E0021': '事件番号より事件名の行数が多い為、テキストの取込ができません',
  'MSG-SK-E0022': 'テスト問題の正解が選択肢の中に存在していません。選択肢内容：{0}',
  'MSG-SK-E0023': 'OCR読込処理に失敗しました。しばらく待ってから再試行するか、改善しない場合はシステム管理者に連絡してください。',
  'MSG-SK-E0024': '一つの法令名に対し，複数の条番号、項番号、号番号を設定することはできません。',
  'MSG-SK-E0025': 'アップロードするファイルは空ファイルです、ご確認ください。',
  'MSG-SK-E0026': '選択肢が歯抜けの状態になっております、ご確認ください。',
  'MSG-SK-E0027': '削除する大分類に紐づく中分類、小分類をすべて選択してください。',
  'MSG-SK-E0028': '削除する中分類に紐づく小分類をすべて選択してください。',
  'MSG-SK-E0029': 'テキストファイル名の後2桁は連番にしてください。',
  'MSG-SK-E0030': '条番号は半角数字とハイフンで「X」、「X-X」、「X-X-X」の形式で入力してください。',
  'MSG-SK-E0031': 'テキストファイル名と分割PDFファイル名の1から4桁は半角数字で入力してください。',
  'MSG-SK-E0032': 'テキストファイル名と分割PDFファイル名の3から4桁は1～12の数値を入力してください。',
  'MSG-SK-E0033': '更新された整理番号は既に存在しているため、修正してください。',
  'MSG-SK-E0034': '追加された分類コードが最大値を超えるため、システム管理者と連絡してください。',
  'MSG-SK-E0035': 'ユーザIDが最大値を超えるため、システム管理者へ連絡してください。',
  'MSG-KK-E0001': '検索種別が選択されていません。\n選択してから検索を実行してください。',
  'MSG-YS-E0001': '{0}確認の状態（未／中／済）が同じ事件を選択してください。',
  'MSG-YS-E0002': '確認権限がない事件が含まれています。',
  'MSG-YS-E0003': '{0}確認が{1}に変更することができない事件が含まれています。',
  'MSG-YS-E0004': '別のユーザが該当事件を{0}確認中のため、{1}にはできません。担当課・局：{2}、整理番号：{3}',
  'MSG-YS-E0005': '未回答の質問があります。',
  'MSG-YS-E0006': '選択した事件について閲覧権限がありません。',
  'MSG-YS-E0007': '対象年間の終了年は開始年以降の年を入力してください',
  'MSG-YS-E0008': '確認不要の事件が含まれています。',
  'MSG-YS-E0009': '管区確認が未了の事件が含まれています。',
  'MSG-YS-E0010': '{0}が含まれているため、確認変更はできません。',
  'MSG-YS-E0011': '整理番号：{0}は使用されています。「整理番号編集」ボタンから新規番号を取得し、再度{1}ボタンを押下してください。',
  'MSG-YS-E0012': '事件記録が作成されていませんので、ファイルを登録してください。',
  'MSG-YS-E0013': '終了していない事件が含まれています。',
  'MSG-YS-E0014': '選択した事件について登録・編集できません。',
  'MSG-YS-E0015': '事件を一つだけ選択してください。',
  'MSG-YS-E0016': '事件終了するには整理番号、受理年月日、終了年月日、終了事由、担当者、回答要旨、論点を登録してください。',
  'MSG-YS-E0017': '出力対象が選択されていません。',
  'MSG-YS-E0018': '事件終了は共同処理の項目（整理番号・受理年月日・終了年月日・終了事由）も含めすべて入力されていないと事件終了することはできません。',
  'MSG-ZH-E0001': '該当する裁判例がありません。'
}